import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '@assets/css/navbar.css';

const Navi = (props) => {
    const [selectedNo, setSelectedNo] = useState('');
    const [openMenuNo, setOpenMenuNo] = useState('');
    const [hoveredMenuNo, setHoveredMenuNo] = useState(null);
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    // 관리자 권한 확인
    useEffect(() => {
        const userInfoStr = sessionStorage.getItem('userInfo');
        if (userInfoStr) {
            try {
                const userInfo = JSON.parse(userInfoStr);
                setIsAdmin(userInfo.loginPermtCd === 'ROLE_ADMIN');
            } catch (e) {
                console.error('Failed to parse userInfo:', e);
                setIsAdmin(false);
            }
        } else {
            setIsAdmin(false);
        }
    }, []);

    const navGnb = [
      { no : '1', label: '기본정보', level: '1', icon: 'bi-info-circle',
        child: [
          { no: '11', level: '2', label: '선수관리', to: '/sys/bs/player-mng' },
          { no: '12', level: '2', label: '부문관리', to: '/sys/bs/division-mng' },
          { no: '13', level: '2', label: '체급관리', to: '/sys/bs/weightClass-mng' },
          { no: '14', level: '2', label: '서포터즈관리', to: '/sys/bs/supporters-mng' },
        ]
      },
      { no : '2', label: '대회정보', level: '1', icon: 'bi-trophy',
        child: [
          { no: '21', level: '2', label: '대회관리', to: '/sys/cm/competition-mng' },
          { no: '22', level: '2', label: '대회신청양식관리', to: '/sys/cm/competitionForm-mng' },
          { no: '23', level: '2', label: '대회신청관리', to: '/sys/cm/competitionApply-mng' },
          { no: '24', level: '2', label: '대회토너먼트관리', to: '/sys/cm/matchmaking-mng' },
        ]
      },
      { no : '3', label: '상태정보', level: '1', icon: 'bi-bar-chart',
        child: [
          { no: '31', level: '2', label: '대진선수정보', to: '/sys/cm/matchdtl-mng' },
          { no: '32', level: '2', label: '대진토너먼트정보', to: '/sys/cm/matchtrmnt-mng' },
          { no: '33', level: '2', label: '대진결과정보', to: '/sys/cm/matchResult-mng' },
        ]
      },
      ...(isAdmin ? [
        { no : '4', label: '어드민관리', level: '1', icon: 'bi-shield-lock',
          child: [
            { no: '41', level: '2', label: '외부대회허용관리', to: '/adm/cm/cmptnAllow-mng' },
          ]
        }
      ] : []),
    ];

    // 스크롤 이벤트 핸들러
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY < 10) {
                setIsVisible(true);
            } else if (currentScrollY > lastScrollY) {
                setIsVisible(false);
                setIsMobileMenuOpen(false);
                setHoveredMenuNo(null);
            } else {
                setIsVisible(true);
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [lastScrollY]);

    // Handle menu click for level1 (parent menu) - 모바일용
    const handleMenuClick = (menuItem) => {
        setOpenMenuNo(openMenuNo === menuItem.no ? '' : menuItem.no);
    };

    // Handle item click for level2 (child menu)
    const handleItemClick = (item) => {
        setSelectedNo(item.no);
        setIsMobileMenuOpen(false);
        setHoveredMenuNo(null);

        // Find parent menu
        const parentMenu = navGnb.find(menu =>
            menu.child && menu.child.some(child => child.no === item.no)
        );

        if (parentMenu) {
            props.onChange && props.onChange(item, parentMenu.label);
        }
    };

    // 모바일 메뉴 토글
    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    // 초기 로드시 path에 맞는 메뉴 활성화
    useEffect(() => {
        const currentPath = window.location.pathname;
        const allNavItems = navGnb.flatMap(menu => menu.child || []);

        // 1. System 메인 페이지(/sys 또는 /sys/main)로 이동한 경우 - 아무것도 선택하지 않음
        if (currentPath === '/sys' || currentPath === '/sys/main') {
            setSelectedNo('');
            sessionStorage.removeItem('page::path');
            sessionStorage.removeItem('page::title');
            sessionStorage.removeItem('page::breadcumb');
            return;
        }

        // 2. 현재 URL이 system 메뉴 중 하나와 일치하는지 확인
        const foundByCurrentPath = allNavItems.find(item => item.to === currentPath);
        if (foundByCurrentPath) {
            handleItemClick(foundByCurrentPath);
            return;
        }

        // 3. sessionStorage의 path 확인 (다른 system 페이지에서 새로고침한 경우)
        const savedPath = sessionStorage.getItem('page::path') || '';
        if (savedPath && savedPath !== '/sys' && savedPath !== '/sys/main') {
            const foundBySavedPath = allNavItems.find(item => item.to === savedPath);
            if (foundBySavedPath) {
                handleItemClick(foundBySavedPath);
                return;
            }
        }

        // 4. 기본값: 아무것도 선택하지 않음
        setSelectedNo('');
        // eslint-disable-next-line
    }, []);

    return (
        <header className={`navbar-custom ${isVisible ? 'navbar-visible' : 'navbar-hidden'}`}>
            <div className="container">
                <div className="navbar-content">
                    {/* 로고 영역 */}
                    <div className="navbar-brand">
                        <Link
                            to="/"
                            className="text-white text-decoration-none"
                            style={{
                                backgroundColor: 'rgba(255, 215, 0, 0.2)',
                                padding: '6px',
                                borderRadius: '6px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                marginRight: '12px',
                                border: '1px solid rgba(255, 215, 0, 0.3)',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = 'rgba(255, 215, 0, 0.3)';
                                e.currentTarget.style.borderColor = 'rgba(255, 215, 0, 0.5)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'rgba(255, 215, 0, 0.2)';
                                e.currentTarget.style.borderColor = 'rgba(255, 215, 0, 0.3)';
                            }}
                            title="Home으로 이동"
                        >
                            <i className="bi bi-house-door-fill" style={{ fontSize: '1.5rem', lineHeight: 1 }}></i>
                        </Link>
                        <Link
                            to="/sys/main"
                            className="text-white text-decoration-none fw-bold"
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center'
                            }}
                            onClick={() => {
                                setSelectedNo('');
                                sessionStorage.removeItem('page::path');
                                sessionStorage.removeItem('page::title');
                                sessionStorage.removeItem('page::breadcumb');
                            }}
                        >
                            <i className="bi bi-gear-fill me-2" style={{ fontSize: '1.5rem', lineHeight: 1 }}></i>
                            SYSTEM
                        </Link>
                    </div>

                    {/* 데스크톱 메뉴 */}
                    <nav className="navbar-menu-desktop">
                        {navGnb.map((menu) => (
                            <div
                                key={menu.no}
                                className="navbar-menu-parent"
                                onMouseEnter={() => setHoveredMenuNo(menu.no)}
                                onMouseLeave={() => setHoveredMenuNo(null)}
                            >
                                <div className="navbar-menu-item">
                                    <i className={`bi ${menu.icon}`}></i>
                                    {menu.label}
                                    <i className="bi bi-chevron-down ms-1" style={{ fontSize: '0.75rem' }}></i>
                                </div>

                                {/* 드롭다운 메뉴 */}
                                <div className={`navbar-dropdown ${hoveredMenuNo === menu.no ? 'show' : ''}`}>
                                    {menu.child && menu.child.map((item) => (
                                        <Link
                                            key={item.no}
                                            to={item.to}
                                            className={`navbar-dropdown-item ${selectedNo === item.no ? 'active' : ''}`}
                                            onClick={() => handleItemClick(item)}
                                        >
                                            {item.label}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </nav>

                    {/* 모바일 햄버거 메뉴 버튼 */}
                    <div className="navbar-actions">
                        <button
                            className="navbar-toggler"
                            type="button"
                            onClick={toggleMobileMenu}
                            aria-label="Toggle navigation"
                        >
                            <span className={`navbar-toggler-icon ${isMobileMenuOpen ? 'open' : ''}`}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </span>
                        </button>
                    </div>
                </div>

                {/* 모바일 메뉴 */}
                <div className={`navbar-menu-mobile ${isMobileMenuOpen ? 'open' : ''}`}>
                    {navGnb.map((menu) => (
                        <div key={menu.no}>
                            <div
                                className="navbar-menu-mobile-parent"
                                onClick={() => handleMenuClick(menu)}
                            >
                                <i className={`bi ${menu.icon}`}></i>
                                {menu.label}
                                <i className={`bi bi-chevron-${openMenuNo === menu.no ? 'up' : 'down'} ms-auto`}></i>
                            </div>

                            {/* 모바일 하위 메뉴 */}
                            <div className={`navbar-submenu-mobile ${openMenuNo === menu.no ? 'open' : ''}`}>
                                {menu.child && menu.child.map((item) => (
                                    <Link
                                        key={item.no}
                                        to={item.to}
                                        className={`navbar-submenu-mobile-item ${selectedNo === item.no ? 'active' : ''}`}
                                        onClick={() => handleItemClick(item)}
                                    >
                                        {item.label}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </header>
    );
};

export default Navi;